module.exports = __webpack_public_path__ + "img/ja.d3c0e7b4.svg";